import { cva as e } from "class-variance-authority";
// src/design/stat-group/style.ts
var t = e("grid gap-3", {
	variants: { columns: {
		2: "grid-cols-2",
		3: "grid-cols-2 md:grid-cols-3",
		4: "grid-cols-2 md:grid-cols-4"
	} },
	defaultVariants: { columns: 4 }
}), n = e("flex min-w-0 flex-col rounded-lg border border-border bg-card p-3 text-foreground no-underline transition-all duration-normal", {
	variants: { interactive: {
		true: "cursor-pointer hover:shadow-md focus-ring",
		false: ""
	} },
	defaultVariants: { interactive: !1 }
}), r = e("text-xs leading-normal font-medium text-muted-foreground"), i = e("mt-1 text-2xl font-semibold tabular-nums", {
	variants: { tone: {
		default: "text-foreground",
		warning: "text-warning-text",
		danger: "text-destructive-text"
	} },
	defaultVariants: { tone: "default" }
}), a = e("mt-0.5 text-xs leading-normal text-muted-foreground"), o = () => ({
	root: t,
	item: n,
	label: r,
	value: i,
	detail: a
});
export { o as getStyles };

//# sourceMappingURL=style.js.map